import React from 'react';
import { FaList, FaChartLine } from 'react-icons/fa';
import '../ScannerViewDemo.css';

interface ViewModeToggleProps {
    viewMode: 'list' | 'chart';
    onViewModeChange: (mode: 'list' | 'chart') => void;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ viewMode, onViewModeChange }) => {
    return (
        <div className="view-toggle-container">
            <div className="view-toggle">
                <button
                    className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
                    onClick={() => onViewModeChange('list')}
                >
                    <FaList />
                    <span>List View</span>
                </button>
                <button
                    className={`view-toggle-btn ${viewMode === 'chart' ? 'active' : ''}`}
                    onClick={() => onViewModeChange('chart')}
                >
                    <FaChartLine />
                    <span>Chart View</span>
                </button>
            </div>
        </div>
    );
};

export default ViewModeToggle;
